function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.8 5.3h10.4c.6 0 1 .5 1 1v6.5c0 .6-.4 1-1 1H4.8c-.5 0-1-.4-1-1V6.3c0-.5.5-1 1-1zm-.7.3l5.9 5.3 5.9-5.2",
  fill: "none",
  strokeWidth: ".5",
  stroke: "currentColor"
}));